import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import lodash from 'lodash'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue-next'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap-vue-next/dist/bootstrap-vue-next.css'
import '@/vee-validate'
import { createMetaManager } from 'vue-meta'
import { i18n } from './translate'
import eventBus from './helpers/eventBus'
// Import our custom OTP Input component
import OtpInput from './components/OtpInput'
// Import mixins
import { applyMixins } from './mixins';
// Import common components registration function
import { registerComponents } from '@/helpers/common-components';
// Import validation wrapper components

// Create Vue 3 app instance
export const app = createApp(App)

// Register global components
app.component("v-otp-input", OtpInput);

// Use plugins
app.use(createMetaManager())
app.use(BootstrapVue)
app.use(IconsPlugin)
app.use(i18n)
app.use(router)
app.use(store)

// Global properties
app.config.globalProperties._ = lodash;
// Make lodash available in all components
window._ = lodash;

// Event bus for Vue 3 (replacing $eventHub)
app.config.globalProperties.$eventHub = eventBus

// Setting shortcut for locale
Object.defineProperty(app.config.globalProperties, 'locale', {
  get () {
    return i18n.global.locale.value
  },
  set (value) {
    i18n.global.locale.value = value
    window.localStorage.setItem('lang', value)
  }
})

// Apply mixins to the app
applyMixins(app);

// Register common components
registerComponents(app);

// Production tip
app.config.productionTip = false

// Mount the app
app.mount('#app > div')
